import * as angular from 'angular';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts/highstock';

export function sparklineChartV2(): ng.IDirective {
  return {
    restrict: 'E',
    template: '<div></div>',
    scope: {
      options: '='
    },
    link: function (scope: any, element: any, attributes: any) {

      const options = {
        title: {
          text: ''
        },
        credits: false,
        chart: {
          width: 58,
          height: 16,
          borderWidth: 0,
          margin: [1, 1, 1, 0],
          type: 'area',
          style: {
            overflow: 'visible'
          },
          skipClone: true,
          zIndex: 100,
          backgroundColor: 'transparent',
        },
        yAxis: {
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          tickPositions: [0],
          showEmpty: false,
        },
        xAxis: {
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          showEmpty: false,
        },
        legend: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{point.y}',
          headerFormat: '',
          hideDelay: 0,
          outside: true,
          shared: true
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            marker: {
              radius: 1,
              states: {
                hover: {
                  radius: 2
                }
              }
            },
            fillOpacity: 0.25
          },
          column: {
            negativeColor: '#910000',
            borderColor: 'silver'
          }
        },
        series: [],
        lang: {
          noData: "No Data"
        }
      };

      // Wait until finished loading, so that the dynamic id's will be ready
      angular.element(document).ready(function () {

        // Load any charts with data (first time)
        try {
          let jsonData = JSON.parse(attributes.data);
          if (jsonData.length === 0) { jsonData = [0, 0, 0, 0]; }
          options.series = [{ data: jsonData }];
          const chart = new Highcharts.Chart(element[0], options as Highcharts.Options);
        } catch (e) {
          return false;
        }

        // watch the data attribute and if it changes, update the chart series
        scope.$watch(function () {
          return element.attr('data');
        }, function (newValue) {
          try {
            if (newValue !== null) {
              let jsonData = JSON.parse(attributes.data);
              if (jsonData.length === 0) { jsonData = [0, 0, 0, 0]; }
              options.series = [{ data: jsonData }];
              const chart = new Highcharts.Chart(element[0], options as Highcharts.Options);
            }
          } catch (e) {
            return false;
          }
        });
      });
    }
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/sparklineChartsV2.ts